/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum SubSideNavItemDestinationsEnum {
    MAIN = 1,
    INFORMATION = 2,
    USERS = 3,
    DIARY = 4,
    TODO = 5,
    RATE_TABLES = 6,
    RATING = 7,
    DEFAULT = 8,
    INCIDENTS = 9,
    HISTORY = 10,
    CLAIMS = 11,
    PAYMENTS_BATCH = 12,
    CLAIMS_LANDING = 13,
    PAYMENTS_HISTORY = 14,
    PAYMENTS_APPROVALS = 15,
    BILLING_ACTIVITY = 16,
    INCIDENTS_INCIDENT_SECTIONS = 17,
    BILLING_PAYROLL_REPORTS = 18,
    BILLING_PAYROLL_REPORT_DETAILS = 19,
    POLICY_QUOTE_SECTIONS = 20,
    POLICY_CANCELLATION = 21,
    PAYMENTS_RECURRING = 22,
    BILLING_ACCOUNTS = 23,
    ENDORSEMENT_SECTIONS = 24,
    BILLING_SCHEDULED_TRANSACTIONS = 25,
    CERTIFICATES = 26,
    AUDIT_SECTIONS = 27,
    EXCESS_REINSURANCE = 28,
    POLICY_WAIVERS = 29,
    POLICY_DIVIDENDS = 30,
}
